(function (root, factory) {
    if (typeof define === 'function' && define.amd) {
        // AMD. Register as an anonymous module.
        define(factory);
    } else if (typeof module === 'object' && module.exports) {
        // CommonJS
        module.exports = factory();
    }
})(this, function () {
    var UNDEF;
    var AMP         = '&';
    var EMPTY       = '';
    var regexcomma  = /\,/g;
    var regexpars   = /(&?\w+\=['"]?)?\{(\w+)(?:\:([^}]+))?\}(['"])?/g;
    var _params     = {};

    /**
     * Template string to parameter insertion.
     * @param  {string} match Entire current match group
     * @param  {[string]} $0    query delimiter capture
     * @param  {[string]} $1    param key
     * @param  {[string]} $2    default value
     * @param  {[string]} $3      query delimiter end
     * @return {string}         resulting substitution
     */
    function replace (match, $0, $1, $2, $3) {
        var val = _params[$1];
        if (val === UNDEF) {
            val = $2;
        }
        if (val !== UNDEF) {
            if ($0 !== UNDEF) {
                var delimiterEnd = $3 !== UNDEF ? $3 :  EMPTY;
                return $0 + (EMPTY + val + delimiterEnd).replace(regexcomma, delimiterEnd + AMP + $0);
            }
            return val;
        }
        return EMPTY;
    }

    return function (str, params) {
        _params = params || {};
        return str && str.replace(regexpars, replace) || EMPTY;
    };
});